import { isArSaLocale } from '@sas/nova-core/i18n/localeUtils';

/**
 * Returns whether or not a year is a leap year.
 */
export function isLeapYear(year) {
  if (year % 4000 === 0) {
    return false;
  } else if (year % 400 === 0) {
    return true;
  } else if (year % 100 === 0) {
    return false;
  } else if (year % 4 === 0) {
    return true;
  } else {
    return false;
  }
}
export function daysInMonth(monthIndex, year) {
  if (monthIndex === 1) {
    return isLeapYear(year) ? 29 : 28;
  } else if (monthIndex === 3 || monthIndex === 5 || monthIndex === 8 || monthIndex === 10) {
    return 30;
  } else {
    return 31;
  }
}
export function* getCalendar(monthIndex, year, locale) {
  const dayOfWeek = new Date(year, monthIndex, 1).getDay();
  const prevYear = monthIndex === 0 ? year - 1 : year;
  const prevMonth = monthIndex === 0 ? 11 : monthIndex - 1;
  const daysInPrevMonth = daysInMonth(prevMonth, prevYear);
  if (locale && isArSaLocale(locale)) {
    const prevDayOfWeek = new Date(prevYear, prevMonth, 1).getDay();
    const prevPrevMonth = monthIndex === 0 ? 10 : monthIndex - 2;
    const daysInPrevPrevMonth = daysInMonth(prevPrevMonth, prevYear);
    {
      for (let i = prevDayOfWeek - 1; i >= 0; --i) {
        yield new Date(prevYear, prevPrevMonth, daysInPrevPrevMonth - i);
      }
    }
    for (let i = 0; i < daysInPrevMonth - dayOfWeek; ++i) {
      yield new Date(prevYear, prevMonth, i + 1);
    }
    {
      for (let i = dayOfWeek - 1; i >= 0; --i) {
        yield new Date(prevYear, prevMonth, daysInPrevMonth - i);
      }
    }
    const daysInCurrMonth = daysInMonth(monthIndex, year);
    for (let i = 0; i < daysInCurrMonth; ++i) {
      yield new Date(year, monthIndex, i + 1);
    }
    {
      const nextYear = monthIndex === 11 ? year + 1 : year;
      const nextMonth = (monthIndex + 1) % 12;
      const lastDayOfWeek = (dayOfWeek + daysInCurrMonth - 1) % 7;
      for (let i = 0; i < 6 - lastDayOfWeek; ++i) {
        yield new Date(nextYear, nextMonth, i + 1);
      }
    }
    {
      const lastDayOfWeek = (dayOfWeek + daysInCurrMonth - 1) % 7;
      const nextYear = monthIndex === 11 ? year + 1 : year;
      const nextMonth = (monthIndex + 1) % 12;
      const daysInNextMonth = daysInMonth(nextMonth, nextYear);
      for (let i = 6 - lastDayOfWeek; i < daysInNextMonth; ++i) {
        yield new Date(nextYear, nextMonth, i + 1);
      }
    }
    return;
  } else {
    {
      for (let i = dayOfWeek - 1; i >= 0; --i) {
        yield new Date(prevYear, prevMonth, daysInPrevMonth - i);
      }
    }
    const daysInCurrMonth = daysInMonth(monthIndex, year);
    for (let i = 0; i < daysInCurrMonth; ++i) {
      yield new Date(year, monthIndex, i + 1);
    }
    {
      const nextYear = monthIndex === 11 ? year + 1 : year;
      const nextMonth = (monthIndex + 1) % 12;
      const lastDayOfWeek = (dayOfWeek + daysInCurrMonth - 1) % 7;
      for (let i = 0; i < 6 - lastDayOfWeek; ++i) {
        yield new Date(nextYear, nextMonth, i + 1);
      }
    }
  }
}
function takeRowsOfSize(rowSize) {
  return function* takeRows(items) {
    let currentRow = [];
    for (const item of items) {
      if (currentRow.length === rowSize) {
        yield currentRow;
        currentRow = [];
      }
      currentRow.push(item);
    }
    if (currentRow.length !== 0) {
      yield currentRow;
    }
  };
}
export function getCalendarRows(monthIndex, year, locale) {
  let result;
  result = getCalendar(monthIndex, year, locale);
  result = takeRowsOfSize(7)(result);
  return [...result];
}

/**
 * Gets the calendar week number for a given day. The calendar week number is defined as:
 *
 * - week 1 starts on the Sunday before or on January 1st of a given year
 *   - However, only days in the given year can be in week 1
 * - week n+1 starts 7 days after the start of week n
 *
 * This differs from a lot of other algorithms because they start the week on Monday instead
 * of Sunday (and have different rules about January 1st).
 */
export function getCalendarWeekNumber(year, monthIndex) {
  // start with the day of the week of the Jan 1st (this is the offset from the start of the first week)
  let totalDays = new Date(year, 0, 1).getDay();
  for (let i = 0; i < monthIndex; ++i) {
    totalDays += daysInMonth(i, year);
  }
  return 1 + Math.floor(totalDays / 7);
}

/**
 * This is the first year the gregorian calendar was implemented.
 */
export const MIN_GREGORIAN_CALENDAR_YEAR = 1582;
export const MAX_GREGORIAN_CALENDAR_YEAR = 9999;
export const MIN_GREGORIAN_CALENDAR_DATE = new Date(MIN_GREGORIAN_CALENDAR_YEAR, 0, 1);
export const MAX_GREGORIAN_CALENDAR_DATE = new Date(MAX_GREGORIAN_CALENDAR_YEAR, 11, 31);
//# sourceMappingURL=GregorianCalendarFacts.js.map